import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import viewProfileImage01 from "@/assets/images/help/view-profile-01.png";

export default function HelpProfile() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-9">
          <h1 className="text-[32px] font-bold leading-[1.6] opacity-80">
            View Profile
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-9">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Profile Screen Overview
              {"\n"}On the Profile screen, you can easily access and manage key
              account functions such as viewing user information, changing your
              password, and logging out.
            </p>
          </div>

          {/* Main Content */}
          <div className="space-y-4">
            <div className="rounded-lg overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={viewProfileImage01}
                alt="View Profile"
                className="w-full h-auto"
              />
            </div>
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              You can also quickly check your account status and registered
              information, ensuring safe and convenient use of your Fellas Card.
              {"\n\n"} · View User Information: Check registered information
              such as your account email and name.
              {"\n\n"} · Change Password: Change your password when necessary.
              {"\n\n"} · Log Out: Safely log out after use.
            </p>
          </div>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/16")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: Password Change Guide</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
